import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { RoomI18nEditContainer } from "@/components/features/items/edit/room/standard/i18n/ui/existing";

import { useGetRoomI18nParams } from "./_hooks/use-get-room-i18n-params";

export const RoomEditPageI18n = () => {
	const { hotelID, roomID, activeLangCode, navigator } = useGetRoomI18nParams();

	return (
		<PageMeta
			title="部屋の編集"
			url={generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.I18N, { hotelID, roomID, langCode: activeLangCode })}
		>
			<RoomI18nEditContainer
				hotelID={hotelID}
				roomID={roomID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

RoomEditPageI18n.displayName = "RoomEditPageI18n";
